const platform = typeof window !== 'undefined' ? (window.Telegram?.WebApp as any)?.platform : undefined;

export const isMobilePlatform = platform === 'android' || platform === 'android_x' || platform === 'ios';